/* Three-step enhancement. Data stays in the form DOM; nothing is persisted or sent early. */
(() => {
  "use strict";
  if (window.OrtluxContact) {
    window.OrtluxContact.init(document);
    return;
  }

  function init(root) {
    root.querySelectorAll("[data-ox-contact]").forEach((section) => {
      const form = section.querySelector("form");
      if (!form || form.dataset.contactReady) return;
      const steps = [...form.querySelectorAll("[data-contact-step]")];
      if (!steps.length) return;
      form.dataset.contactReady = "true";
      form.noValidate = true;

      const markers = [...form.querySelectorAll("[data-step-marker]")];
      const next = form.querySelector("[data-contact-next]");
      const back = form.querySelector("[data-contact-back]");
      const submit = form.querySelector("[data-contact-submit]");
      const error = form.querySelector("[data-contact-errors]");
      const message = form.elements.namedItem("contact[body]");
      const orderField = form.querySelector("[data-order-field]");
      error.id = `${form.id}-errors`;
      let current = 0;

      const selectedTopic = () => form.querySelector("[data-topic]:checked");
      const hints = {
        advice: "What routes do you ride and which model interests you? Tell us what matters to you.",
        order: "Tell us about your order question. An order number is helpful but optional.",
        service: "Describe the issue and the model. Please do not send payment details or passwords.",
        other: "Tell us about your question. Please do not send payment details or passwords.",
      };

      function updateTopic() {
        const topic = selectedTopic()?.dataset.topic;
        form.querySelector("[data-topic-hint]").textContent = hints[topic] || hints.other;
        const needsOrder = topic === "order" || topic === "service";
        orderField.hidden = !needsOrder;
        orderField.querySelector("input").disabled = !needsOrder;
      }

      function updateSummary() {
        form.querySelector("[data-summary-topic]").textContent = selectedTopic()?.value || "";
        form.querySelector("[data-summary-body]").textContent = message.value;
      }

      function clearError() {
        error.hidden = true;
        form.querySelectorAll("[aria-invalid]").forEach((field) => {
          field.removeAttribute("aria-invalid");
          field.removeAttribute("aria-errormessage");
        });
      }

      function showStep(index, focus = true) {
        current = index;
        form.dataset.oxStep = String(index);
        steps.forEach((step, i) => {
          step.hidden = i !== index;
        });
        markers.forEach((marker, i) => {
          if (i === index) marker.setAttribute("aria-current", "step");
          else marker.removeAttribute("aria-current");
        });
        back.hidden = index === 0;
        next.hidden = index === steps.length - 1;
        submit.hidden = index !== steps.length - 1;
        form.querySelector("[data-step-status]").textContent = `Step ${index + 1} of ${steps.length}`;
        clearError();
        updateSummary();
        if (focus) steps[index].querySelector("legend").focus({ preventScroll: false });
      }

      function errorText(field) {
        if (field.type === "radio") return "Please choose a topic for your enquiry.";
        if (field.type === "checkbox") return "Please confirm that you have read the privacy information.";
        if (field.type === "email") return "Please enter a valid email address for our reply.";
        if (field === message) return "Please describe your question in 10 to 5,000 characters.";
        return "Please enter your name.";
      }

      function validateStep(index) {
        const fields = [...steps[index].querySelectorAll("input, textarea, select")];
        const invalid = fields.find((field) => !field.disabled && !field.checkValidity());
        if (!invalid) {
          clearError();
          return true;
        }
        error.textContent = errorText(invalid);
        error.hidden = false;
        invalid.setAttribute("aria-invalid", "true");
        invalid.setAttribute("aria-errormessage", error.id);
        invalid.focus();
        return false;
      }

      form.querySelectorAll("[data-contact-enhanced]").forEach((el) => {
        el.hidden = false;
      });
      form.querySelectorAll("[data-topic]").forEach((radio) =>
        radio.addEventListener("change", () => {
          updateTopic();
          clearError();
        }),
      );
      next.addEventListener("click", () => {
        if (validateStep(current)) showStep(current + 1);
      });
      back.addEventListener("click", () => showStep(Math.max(0, current - 1)));
      form
        .querySelectorAll("[data-edit-step]")
        .forEach((button) =>
          button.addEventListener("click", () => showStep(Number(button.dataset.editStep))),
        );
      form.addEventListener("submit", (event) => {
        if (current < steps.length - 1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (validateStep(current)) showStep(current + 1);
          return;
        }
        for (let index = 0; index < steps.length; index++) {
          const invalid = [...steps[index].querySelectorAll("input, textarea, select")].some(
            (field) => !field.disabled && !field.checkValidity(),
          );
          if (invalid) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showStep(index);
            validateStep(index);
            return;
          }
        }
        // Valid: allow the native Shopify contact POST. The offline preview intercepts separately.
      });
      updateTopic();
      showStep(0, false);
      if (form.querySelector("[data-ox-contact-server-error]")) {
        // Keep all returned content editable; server errors remain visible above the steps.
        showStep(2, false);
        form.querySelector("[data-ox-contact-server-error]").focus();
      }
    });
  }

  window.OrtluxContact = { init };
  document.addEventListener("shopify:section:load", (event) => init(event.target));
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init(document));
  else init(document);
})();
